import { TiemposDisponibles } from '@/components/AvailabilityScheduler';

export interface InstitutionSchedule {
  id: number;
  name: string;
  description: string | null;
  tiemposDisponibles: TiemposDisponibles | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface InstitutionScheduleInput {
  name: string;
  description: string | null;
  tiemposDisponibles: TiemposDisponibles | null;
  isActive: boolean;
}

export async function getInstitutionSchedules(): Promise<InstitutionSchedule[]> {
  const response = await fetch('/api/institution-schedules', {
    credentials: 'include',
  });

  if (!response.ok) {
    throw new Error('Error al cargar horarios');
  }

  return response.json();
}

export async function createInstitutionSchedule(
  data: InstitutionScheduleInput
): Promise<InstitutionSchedule> {
  const response = await fetch('/api/institution-schedules', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    throw { response: { data: error } };
  }

  return response.json();
}

export async function updateInstitutionSchedule(
  id: number,
  data: InstitutionScheduleInput
): Promise<InstitutionSchedule> {
  const response = await fetch(`/api/institution-schedules/${id}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.json();
    throw { response: { data: error } };
  }

  return response.json();
}

export async function deleteInstitutionSchedule(id: number): Promise<void> {
  const response = await fetch(`/api/institution-schedules/${id}`, {
    method: 'DELETE',
    credentials: 'include',
  });

  if (!response.ok) {
    const error = await response.json();
    throw { response: { data: error } };
  }
}
